import Link from "next/link";
import { Tactic } from "@/types/tactic";
import React from "react";
import { LockClosedIcon } from "@heroicons/react/24/solid";
import { LockOpenIcon } from "@heroicons/react/24/outline";
import { useCurrentUser } from "@/hoc/useCurrentUser";
import Image from "next/image";

export const TacticCard = ({ tactic }: { tactic: Tactic }) => {
  const { currentUser } = useCurrentUser();
  return (
    <Link
      href={`/tactics/${tactic?.id}`}
      className={"relative hover:opacity-60 duration-300"}
    >
      <div className={"relative mb-2"} style={{ lineHeight: 0 }}>
        {tactic?.image && (
          <img
            width={234}
            height={122}
            src={tactic.image}
            className={"w-full rounded"}
          />
        )}
      </div>
      <p>
        {!tactic?.is_free &&
          (currentUser?.is_subscribed ? (
            <LockOpenIcon
              className={"inline-block mr-1 -mt-1 w-5 text-orange-400"}
            />
          ) : (
            <LockClosedIcon
              className={"inline-block mr-1 -mt-1 w-5 text-orange-400"}
            />
          ))}
        {tactic.sort_order > 0 && (
          <span
            className={
              "relative top-[-2px] inline-block text-[10px] font-bold bg-blue-700 text-white mr-1 py-px px-2 rounded"
            }
          >
            第{tactic.sort_order}回
          </span>
        )}
        {tactic?.title}
      </p>
      {tactic?.is_attended && (
        <div className={"absolute top-0 right-0"}>
          <Image
            src={"/images/attendance.png"}
            alt={"受講済み"}
            width={50}
            height={50}
          />
        </div>
      )}
      {tactic?.status === "draft" && (
        <div className={"absolute top-0 right-0"}>
          <Image
            src={"/images/draft.png"}
            alt={"下書き"}
            width={50}
            height={50}
          />
        </div>
      )}
    </Link>
  );
};
